import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as config from '../shared/config/app.config';
import { OpenInvoices } from '../shared/models/invoices.model';
import { BaseService } from '../shared/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class MakeAPaymentService {
  public makePaymentData = new BehaviorSubject<any>(false); // behaviour subject containing the parent data of invoices & credit
  makePaymentData$ = this.makePaymentData.asObservable();
  public makePaymentInvoiceData = new BehaviorSubject<OpenInvoices>(null);
  makePaymentInvoiceData$ = this.makePaymentInvoiceData.asObservable();

  public creditData = new BehaviorSubject<boolean>(false); // behaviour subject containing the credit Data
  creditData$ = this.creditData.asObservable();
  public invoiceCreditData = new BehaviorSubject<boolean>(false); // behaviour subject containing the credit Data
  invoiceCreditData$ = this.invoiceCreditData.asObservable();

  emails: any;
  emails$: any;
  constructor(private readonly baseService: BaseService, private readonly globalMessage?: GlobalMessageService,) { }

  public getInvoices(params): void {
    this.makePaymentData.next(false);
    this.baseService.get(config.GET_INVOICES, params).subscribe((res) => {
      this.makePaymentData.next(res);
    });
  }
  public getPaymentInvoices(params): void {
    this.makePaymentInvoiceData.next(null);
    this.baseService.get(config.GET_INVOICES, params).subscribe((res) => {
      this.makePaymentInvoiceData.next(res);
    });
  }

  public downloadPdf(params): void {
    var windowReference = window.open();
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_CREDIT_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        windowReference.location = fileURL;
      }, error => {
        this.globalMessage.add('Requested document is not available at this moment', GlobalMessageType.MSG_TYPE_ERROR);
      });
  }

  public getCardDetails(params): any {
    return this.baseService.get(config.GET_CARD_DETAILS, params);
  }

  public saveCreditDetails(userName, params) {
    return this.baseService.patch(
      `${config.USER_ACCOUNT}${userName}/payment-confirmation-credit`,
      params
    );
  }

  public makeCreditCardPayment(userName, params) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userName}/ccinvoice-payment`,
      params
    );
  }

  public getAccountId(userName): Observable<any> {
    return this.baseService.get(`${config.USER_ACCOUNT}${userName}/b2bUnits`);
  }

  getEmails(userId, b2bUnitID): void {
    this.emails = new BehaviorSubject<any>(false);
    this.emails$ = this.emails.asObservable();
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/customerEmails?b2bUnitId=${b2bUnitID}`).subscribe((res) => {
        if (res) {
          this.emails.next(res);
        }
      });
  }

  public initiateCreditRefund(userId, b2bUnitId, requestObj) {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/credit-payment-confirmation?b2bUnitUid=${b2bUnitId}&fields=DEFAULT`, requestObj);
  }

  download_Xls_Pdf(param, type) {
    this.baseService
      .getPdf(`my-account/allInvoices-export/${type}`, param)
      .subscribe((res) => {
        const file = new Blob([res], { type: `application/${type}` });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `invoiceDetails.${type}`;
        link.click();
      });
  }

  deleteScheduledPayment(userId, payload): Observable<any> {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/cancel-scheduled-payment`, payload);
  }

  editScheduledPayment(userId, payload): Observable<any> {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/edit-scheduled-payment`, payload);
  }

  public payAtTerms(userName, params) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userName}/payByTerms`,
      params
    );
  }
}